import React, {useState} from "react";
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import useFetch from '../../../../hooks/useFetch'
import FermeturesAPI from '../../../../services/FermeturesAPI'
import Count from '../../../ui/page/Count'
import {HolidaysContentTab} from './HolidaysContentTab'
import {HolidaysForm} from './HolidaysForm'

export const Holidays = () => {
    const [{data: holidays, totalItems, isLoading, isError}, fetchData] = useFetch(FermeturesAPI.getFermetures());
    const [showAddHolidaysModal, setShowAddHolidaysModal] = useState(false);

    return (
        <>
            <Col>
                <div className={'bg-light p-3 d-flex align-items-center border-left border-right border-top'}>
                    <Col className={'my-auto'}>
                        <h3>Dates de congés/fermetures</h3>
                    </Col>
                    <Col className={'my-auto d-lg-flex justify-content-end'}>
                        <Button
                            onClick={() => setShowAddHolidaysModal(true)}
                            variant={'primary'}
                            className={'mr-3'}
                        >
                            <FontAwesomeIcon
                                icon="plus-circle"
                                color="white"
                                className="mr-2"
                            />
                            Ajouter
                        </Button>
                        <Count totalItems={totalItems} name={'congé'} classNames={'my-auto'}/>
                    </Col>
                </div>
                <hr className="m-0" />
                <HolidaysContentTab holidays={holidays} isLoading={isLoading} fetchData={fetchData} isError={isError}/>

                <HolidaysForm
                    show={showAddHolidaysModal}
                    onHide={() => setShowAddHolidaysModal(false)}
                />
            </Col>
        </>
    );
}
